<template>
  <v-content>
    <div 
      class="text-xs-center mt-5">
      <v-avatar 
        size="250px">
        <v-img
         
          class="elevation-12"
          aspect-ratio="1"
          :src="user.profileImg">
          <div class="croppa-container">
            <croppa 
              v-model="myCroppa"
              :width="250"
              :height="250"
              :quality="1"
              accept="image/*"
              :file-size-limit="10000000"
              placeholder=""
              :disabled="false"
              :prevent-white-space="true"
              :show-remove-button="false"
              :zoom-speed="5"

              @file-choose="handleCroppaFileChoose"
              @file-size-exceed="handleCroppaFileSizeExceed"
              @file-type-mismatch="handleCroppaFileTypeMismatch"
              @image-remove="handleCroppa"
              @move="handleCroppa"
              @zoom="handleCroppa">  
              <img 
                slot="placeholder"
                src="@/assets/camera.png">
            </croppa>
          </div>
        </v-img>
        <v-btn 
          v-if="path === '/profile'"
          style="transform: translate(-92px, 92px); height: 32px; width: 32px;"
          absolute
          fab
          color="primary"
          :loading="this.$store.getters.loading"
          @click="clickCheck">
          <v-icon 
            small>
            fas fa-check
          </v-icon>
        </v-btn>

        <v-btn 
          v-if="path === '/profile' && newCroppaImg"
          style="transform: translate(88px, -88px); height: 26px; width: 26px;"
          absolute
          fab
          color="red"
          dark
          @click="removeCroppaImg">
          <v-icon 
            size="14">
            fas fa-times
          </v-icon>
        </v-btn>

        <v-btn 
          v-if="path === '/profile' && newCroppaImg"
          style="transform: translate(125px, 0); height: 26px; width: 26px;"
          absolute
          fab
          color="grey darken-1"
          dark
          @click="myCroppa.rotate()">
          <v-icon 
            size="14">
            fas fa-redo
          </v-icon>
        </v-btn>
      </v-avatar>


        
      <v-flex 
        v-if="error" 
        class="mt-4"
        xs12
        md4
        offset-md4>
        <app-alert 
          :text="error.message" 
          @dismissed="onDismissed"></app-alert>
      </v-flex>

      <v-layout
        style="max-width: 420px; margin: auto;"
        row 
        wrap
        justify-center>
        <v-flex 
          class="mt-5"
          xs8>
          <!-- <span class="caption grey--text text--darken-1">
              This is your displayed name
            </span> -->

          <!-- @keydown.space.prevent -->
          <v-text-field
            v-model.trim="newName"
            :error-messages="newNameErrors"
            :placeholder="user.name"
            :append-icon="newName ? 'fas fa-times' : ''"
            :label="newName ? 'New Name' : 'Name'"
            :dont-fill-mask-blanks="true"
            hint="The name can only be changed every 3 months."
            name="name"
            type="text"
            @click:append="clearName"
            @focus="checkLastChange"
            @change="$v.newName.$touch()">
          </v-text-field>
        </v-flex>
        

         
        <v-flex 
          xs8
          class="mt-3">
          <v-text-field
            v-model="newStatus"
            :error-messages="newStatusErrors"
            :label="newStatus ? 'New Status' : 'Status'"
            :placeholder="user.status"
            :append-icon="newStatus ? 'fas fa-times' : ''"
            name="status"
            type="text"
            @click:append="clearStatus"
            @change="$v.newStatus.$touch()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </div>
  </v-content>
</template>


<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { minLength, maxLength, helpers } from 'vuelidate/lib/validators'
const regExName = helpers.regex('regExName', /^[0-9A-Za-zöÖäÄüÜß]+[0-9A-Za-z:.\s\-_öÖäÄüÜß][0-9A-Za-zöÖäÄüÜß]+$/)

export default {
  data() {
    return {
      myCroppa: {},
      newName: '',
      newStatus: '',
      newCroppaImg: false,
      image: null,
      
    }
  },
  validations: {
    newName: {
      minLength: minLength(3),
      maxLength: maxLength(30),
      regExName,
    },
    newStatus: {
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
  },
  computed: {
    // <!-- TODO: Text/Translate -->

    newNameErrors() {
      const errors = []
      if (!this.$v.newName.$dirty) return errors
      this.newName === this.user.name && errors.push('Why would you use the same name again?')
      !this.$v.newName.maxLength && errors.push('New Name must not have more than ' + this.$v.newName.$params.maxLength.max + ' letters.')
      !this.$v.newName.minLength && errors.push('New Name must have at least ' + this.$v.newName.$params.minLength.min + ' letters.')
      !this.$v.newName.regExName && errors.push('New Name must not start or end with special character or contains space.')
      return errors
    },
    newStatusErrors() {
      const errors = []
      if (!this.$v.newStatus.$dirty) return errors
      this.newStatus === this.user.status && errors.push('Be creative! Hint: Maybe you should use a new one!?')
      !this.$v.newStatus.maxLength && errors.push('New Status must not have more than ' + this.$v.newStatus.$params.maxLength.max + ' letters.')
      !this.$v.newStatus.minLength && errors.push('New Status must have at least ' + this.$v.newStatus.$params.minLength.min + ' letters.')
      return errors
    },
    ...mapState({
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      categories: state => state.categories
    }),
    ...mapGetters({
      user: 'user'
    }),
    
    
    
   
    error () {
      return this.$store.getters.error
    }
   
  },
  deactivated () {
    this.newName = ''
    this.newStatus = ''
    this.newCroppaImg = false
    this.myCroppa.remove()
    this.image = null
    this.$store.dispatch('clearError')
  
  },
  methods: {
    ...mapMutations([
      'setSelectedProfileComp'
    ]),
    clearName() {
      this.newName = ''
    },
    clearStatus() {
      this.newStatus = ''
    },
    handleCroppaFileSizeExceed () {
      this.$store.commit('setError', { message: 'WoW! This is a really big file! Try it with something smaller...' })
      this.newCroppaImg = false
      this.myCroppa.remove()
      this.image = null
    },
    handleCroppaFileTypeMismatch () {
      this.$store.commit('setError', { message: 'Come on sweetheart... This is not an image!' })
      this.newCroppaImg = false
      this.myCroppa.remove()
      this.image = null
    },
    handleCroppaFileChoose () {
      this.newCroppaImg = true
      console.log(this.myCroppa)
    },
    removeCroppaImg () {
      this.myCroppa.remove()
      this.newCroppaImg = false
    },
    handleCroppa () {

    },

    clickCheck() {
      if (!this.myCroppa.hasImage()) {
        // no Image vorhanden
        this.update()
      } else {
        let compressor = 0.9
        if (this.myCroppa.chosenFile.size > 10000000) {
          compressor = 0.5
        } else if (this.myCroppa.chosenFile.size > 5000000){
          compressor = 0.7
        } else {
          compressor = 0.9
        }
        this.myCroppa.generateBlob((blob) => {
        // write code to upload the cropped image file (a file is a blob)
          this.image = blob
          // console.log('blob', this.image)
          this.update()
        }, 'image/jpeg', compressor)
      }
    },


    checkLastChange () {
      if (new Date().getTime() - new Date(this.user.nameChanged).getTime() > 7.884e+9 ) {
        
      } else {
        this.$store.commit('setError', { message: 'The name can only be changed every 3 months.' })
      }
    },

    update () {
      // Vuex
      if (this.newName !== '' && !this.$v.newName.$invalid && this.newName !== this.user.name) {
        if (new Date().getTime() - new Date(this.user.nameChanged).getTime() > 7.884e+9 ) {
          this.$store.dispatch('updateProfile', { 'name': this.newName.replace(/\s\s+/g, ' ') })

        } else {
          this.$store.commit('setError', { message: 'The name can only be changed every 3 months.' })

        }
        
      }
      if (this.newStatus !== '' && !this.$v.newStatus.$invalid && this.newStatus !== this.user.status) {
        this.$store.dispatch('updateProfile', { 'status': this.newStatus.replace(/\s\s+/g, ' ') })
        
      }
      if (this.image !== null) {
        this.$store.dispatch('updateProfile', { 'profileImg': this.image })
       
      }
      this.setSelectedProfileComp('app-profile-display')
      
    },

    
    onDismissed () {
      this.$store.dispatch('clearError')
    },
  }
}
</script>


<style scoped>

  .croppa-container {
   background-color:  rgba(120, 144, 156, 0.4);
 }
 
 .croppa-container:hover {
   opacity: 1;
   background-color:  rgba(120, 144, 156, 0.6);
 }
</style>
